import React, { Component } from "react";
import PropTypes from "prop-types";
import FlipMove from "react-flip-move";
import styles from "./index.module.css";

import Preview from "../Preview";

const PreviewsWrapper = ({ enableAnims, className, children }) => {
  return enableAnims ? (
    <FlipMove
      typeName="div"
      className={className}
      duration={250}
      easing="ease-in-out"
      enterAnimation="fade"
      leaveAnimation="fade"
      maintainContainerHeight
    >
      {children}
    </FlipMove>
  ) : (
    <div className={className}>{children}</div>
  );
};

PreviewsWrapper.propTypes = {
  enableAnims: PropTypes.bool,
  className: PropTypes.string
};

class PreviewList extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    const { previews, selectedId, enableAnims } = this.props;
    return (
      <div className={styles.root}>
        <div className={styles.inner}>
          <div className={styles.header}>
            <h1 className={styles.title}>The Research</h1>
          </div>
          <PreviewsWrapper enableAnims={enableAnims} className={styles.list}>
            {previews.map(preview => (
              <div key={preview.titleNumber}>
                <Preview
                  isSelected={selectedId && selectedId === preview.articleId}
                  {...preview}
                />
              </div>
            ))}
          </PreviewsWrapper>
        </div>
      </div>
    );
  }
}

PreviewList.defaultProps = {
  enableAnims: false
};

PreviewList.propTypes = {
  enableAnims: PropTypes.bool,
  previews: PropTypes.arrayOf(PropTypes.shape({})),
  selectedId: PropTypes.number
};

export default PreviewList;



// WEBPACK FOOTER //
// ./src/components/PreviewList/index.js